<template>
  <div v-if="publicTenderInfo" class="d-contents public-tender">
    <HeaderOfPublicTender />
    <div class="section_public wf-section">
      <div class="public-container">
        <div class="grid">
          <MainColumnOfPublicTender />
          <RightColumnOfPublicTender />
        </div>
      </div>
    </div>
    <PublicTenderModal v-if="showModal" />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import HeaderOfPublicTender from '@/components/public-tender/HeaderOfPublicTender';
  import PublicTenderModal from '@/containers/public-tender/PublicTenderModal';
  import RightColumnOfPublicTender from '@/containers/public-tender/RightColumnOfPublicTender';
  import MainColumnOfPublicTender from '@/containers/public-tender/main-column/MainColumnOfPublicTender';
  import publicTender from '@/store/public-tender';
  import { addModule } from '@/store';

  export default {
    name: 'PublicTender',
    components: {
      MainColumnOfPublicTender,
      RightColumnOfPublicTender,
      PublicTenderModal,
      HeaderOfPublicTender,
    },
    computed: {
      ...mapState('publicTender', ['publicTenderInfo', 'showModal']),
    },
    methods: {
      ...mapActions('publicTender', ['initPublicTenderInfo']),
      updateTitle() {
        if (this.publicTenderInfo?.name) {
          const tenderName = this.publicTenderInfo?.name;
          const generalContractorName = this.publicTenderInfo?.project?.team?.name;
          document.title = `${this.$t('{tenderName} by {generalContractorName}', {
            tenderName: tenderName,
            generalContractorName: generalContractorName,
          })}`;
        }
      },
    },
    async created() {
      addModule('publicTender', publicTender);
      const tenderHash = this.$router.currentRoute.params.tenderHash;
      const offerHash = this.$router.currentRoute.query.c;
      await this.initPublicTenderInfo({ tenderHash, offerHash });
      this.updateTitle();
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
